/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SimpleNotifyModal } from '../../../../components/SimpleNotifyModal/SimpleNotifyModal';
import { Namespaces } from '../../../../i18n';

interface ClusterModalsProps {
  isOpenErrorModal: boolean;
  isOpenPermissionsErrorModal: boolean;
  onCloseErrorModal: () => void;
  onClosePermissionsErrorModal: () => void;
}

const ClusterModals = memo<ClusterModalsProps>(
  ({ isOpenErrorModal, isOpenPermissionsErrorModal, onCloseErrorModal, onClosePermissionsErrorModal }) => {
    const { t } = useTranslation();

    return (
      <>
        <SimpleNotifyModal
          open={isOpenErrorModal}
          onOk={onCloseErrorModal}
          message={t(`${Namespaces.Common}:errors.unexpected_error`)}
        />
        <SimpleNotifyModal
          open={isOpenPermissionsErrorModal}
          onOk={onClosePermissionsErrorModal}
          message={t(`${Namespaces.Rbac}:cluster.error`)}
        />
      </>
    );
  },
);

export { ClusterModals };
